import EpfoLatestDetails from "./Epfo";

export default EpfoLatestDetails;
